<template lang="pug">
TheAppBar
  VContainer.pa-0
    h1.d-sr-only {{ title }}
    TheCommentaryVersePicker(:local-tid="localTid")
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useCommentaryFiltersStore } from "~/stores/useCommentaryFiltersStore";
import { localesByCode } from "~/i18n/locales";
import { never } from "~/never";

const i18n = useI18n();
const localeConfig = computed(
  () => localesByCode.get(i18n.locale.value) ?? never("Locale not found."),
);
const localTid = computed<string>(() => localeConfig.value.defaultTid);

const commentaryFiltersStore = useCommentaryFiltersStore();
const runtimeConfig = useRuntimeConfig();
const title = computed<string>(() => {
  return `Commentary: ${commentaryFiltersStore.getCommentaryType(runtimeConfig.public.commentary.defaultType).name[i18n.locale.value] ?? ""}`;
});
</script>

<style scoped lang="scss">
.v-toolbar,
.the-commentary-verse-picker {
  width: 100%;
}
</style>
